let loadedConfig

export function getAppConfig() {
    if (loadedConfig) {
        return loadedConfig
    }

    return fetch(process.env.PUBLIC_URL + '/app-config.json')
        .then(response => response.json())
        .then(jsonResponse => {
            loadedConfig = jsonResponse
            return loadedConfig
        })
        .catch(err => {
            console.error(`Couldn't load app configuration: ${err}`)
        })
}
